import { Inject, Injectable } from '@angular/core';
import { filter, findLast } from 'lodash';
import { ILoggingService } from '../models/ilogging.service';
import {
  DebugSyncLogMessage,
  ErrorSyncLogMessage,
  InfoSyncLogMessage,
  LoggingModuleOptions,
  LogLevel,
  SyncLogMessage,
  TraceSyncLogMessage,
  WarnSyncLogMessage,
} from '../models/sync-log-message';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SyncLoggingService implements ILoggingService {
  private fullLog: SyncLogMessage[] = [];
  private logLevel: LogLevel;

  get log(): SyncLogMessage[] {
    return filter(this.fullLog, (msg: SyncLogMessage) => msg.logLevel >= this.logLevel);
  }

  get tail(): SyncLogMessage {
    return findLast(this.fullLog, (msg: SyncLogMessage) => msg.logLevel === LogLevel.INFO);
  }

  private logSubject: Subject<SyncLogMessage> = new Subject<SyncLogMessage>();
  get logStream(): Observable<SyncLogMessage> {
    return this.logSubject.asObservable();
  }

  constructor(@Inject(LoggingModuleOptions) options: LoggingModuleOptions) {
    this.logLevel = options.logLevel;
  }

  trace(message: string): void {
    this.next(new TraceSyncLogMessage(message));
  }

  debug(message: string): void {
    this.next(new DebugSyncLogMessage(message));
  }

  info(message: string): void {
    this.next(new InfoSyncLogMessage(message));
  }

  warn(message: string): void {
    this.next(new WarnSyncLogMessage(message));
  }

  error(error: Error, message: string): void {
    this.next(new ErrorSyncLogMessage(error, message));
  }

  clear(): void {
    this.fullLog = [];
  }

  private next(message: SyncLogMessage) {
    this.fullLog.push(message);
    this.logSubject.next(message);
  }
}
